"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.I18N_CHANGE_LOCALE = exports.I18N_TRANSLATE = void 0;
/**
 * i18nProvider types
 */
exports.I18N_TRANSLATE = 'I18N_TRANSLATE';
exports.I18N_CHANGE_LOCALE = 'I18N_CHANGE_LOCALE';
